import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { join } from 'path';
import entityComposition from '../common/classes/entityComposition';
import EditorComponent from '../editor/editorComponent';
import notificationConstants from '../../constants/notificationConstants';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnSave = () => {};
const defaultOnValidate = () => {};
const defaultOperationComplete = () => {};
const defaultOperationPending = () => {};
const FormModal = _ref => {
  let _ref$formModal = _ref.formModal,
    _ref$formModal2 = _ref$formModal === void 0 ? {} : _ref$formModal,
    _ref$formModal2$activ = _ref$formModal2.active,
    active = _ref$formModal2$activ === void 0 ? null : _ref$formModal2$activ,
    _ref$formModal2$onSav = _ref$formModal2.onSave,
    onSave = _ref$formModal2$onSav === void 0 ? defaultOnSave : _ref$formModal2$onSav,
    _ref$formModal2$onVal = _ref$formModal2.onValidate,
    onValidate = _ref$formModal2$onVal === void 0 ? defaultOnValidate : _ref$formModal2$onVal,
    _ref$formModal2$open = _ref$formModal2.open,
    open = _ref$formModal2$open === void 0 ? false : _ref$formModal2$open,
    _ref$formModal2$saveT = _ref$formModal2.saveTitle,
    saveTitle = _ref$formModal2$saveT === void 0 ? 'Save' : _ref$formModal2$saveT,
    _ref$formModal2$title = _ref$formModal2.title,
    title = _ref$formModal2$title === void 0 ? '' : _ref$formModal2$title,
    _ref$formModalActions = _ref.formModalActions,
    change = _ref$formModalActions.change,
    close = _ref$formModalActions.close,
    _ref$notificationActi = _ref.notificationActions,
    validationError = _ref$notificationActi.validationError,
    dismiss = _ref$notificationActi.dismiss;
  if (!active) return null;
  const id = active.content.id,
    format = active.format;
  const handleChange = _ref2 => {
    let path = _ref2.path,
      value = _ref2.value,
      changeModifiers = _ref2.changeModifiers;
    change(id, join('content', path), value, changeModifiers);
  };
  const handleClose = () => {
    close();
  };
  const handleSave = async () => {
    // run validation behaviors
    if (onValidate) {
      const validationResult = await onValidate(active.content);
      if (validationResult) {
        // display validation errors
        validationError({
          list: [validationResult],
          id: notificationConstants.VALIDATION_ERROR
        }, {
          autoClose: 10000
        });
        return;
      }
    }
    dismiss(notificationConstants.VALIDATION_ERROR); // remove validation-error notification

    // if validation passes, run save actions
    await onSave(active.content);
    close();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: open
  }, /*#__PURE__*/React.createElement(ModalHeader, null, title), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(EditorComponent, {
    reduxEntity: "formModal",
    path: "/",
    format: format,
    onChange: handleChange,
    operationComplete: defaultOperationComplete,
    operationPending: defaultOperationPending
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    className: "t-fm-save"
  }, saveTitle), /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    className: "t-fm-cancel"
  }, "Close")));
};
FormModal.propTypes = {
  formModal: PropTypes.shape({
    active: PropTypes.shape({}),
    onSave: PropTypes.func,
    onValidate: PropTypes.func,
    open: PropTypes.bool,
    saveTitle: PropTypes.string,
    title: PropTypes.string
  }),
  formModalActions: PropTypes.shape({
    change: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
  }).isRequired,
  notificationActions: PropTypes.shape({
    validationError: PropTypes.func,
    dismiss: PropTypes.func
  }).isRequired
};
export { FormModal as TestFormModal };
export default entityComposition(FormModal, ['formModal'], {}, ['notification']);